module.exports = __webpack_public_path__ + "img/Matrix.a1360dc3.png";